import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';

export const AnswerBadge = styled.div`
  position: relative;
  padding: ${({ pro }) => (pro ? '3px 12px' : '3px 12px 3px 30px')};
  border-radius: ${({ theme }) => `${theme.borderRadius} ${theme.borderRadius} 0 0`};
  box-shadow: ${({ theme }) => theme.boxShadow};
  margin-left: ${({ extramargin }) => (extramargin ? '54px' : '24px')};
  background: ${({ theme, pro }) => (pro ? theme.mainColor : theme.colors.positive)};
  ${getFont(-1)};
  white-space: nowrap;
  color: #fff;
  user-select: none;
  transform: translateY(21px) translateX(-9px);

  ${({ absolute }) =>
    (absolute
      ? `
      position: absolute;
      right: 48px;
      transition: transform 0.25s ease;

      &:hover {
        transform: translateY(21px) translateX(-100%) translateX(24px);
        transition: transform 0.25s ease;
      }
      `
      : null)};

  svg {
    position: absolute;
    top: 4px;
    left: 6px;
  }

  ${maxMediaQueries.phablet`
    position: absolute;
    right: 0;
    z-index: 2;
    border-radius: ${({ theme }) => `0 0 ${theme.borderRadius} ${theme.borderRadius}`};
    transform: translateY(21px) translateY(100%) translateX(-15px);

    ${({ absolute }) =>
    (absolute
      ? `
      right: 48px;

      &:hover {
        transform: translateY(21px) translateY(100%) translateX(-100%) translateX(24px);
      }
      `
      : null)};
  `};
`;
